export default __webpack_public_path__ + "static/media/Class-9-10-CBSE-Math.932d6e22.pdf";